export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyB9Ckcf-Pyml4Va39RoR9080S33gekmLJ4',
    authDomain: 'leaderboard-developer-demo.firebaseapp.com',
    projectId: 'leaderboard-developer-demo',
    storageBucket: 'leaderboard-developer-demo.appspot.com',
    messagingSenderId: '359126940794',
    appId: '1:359126940794:web:2d9321bcb0dbfe428b4fc3',
  },
  // Needs to be here to prevent undefined bugs, but is not set, to not initialize it.
  sentry: {
    dsn: '',
  },
};
